import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
export const UploadOrImageContainer = styled.div `
  height: 240px;
  width: 160px;
  flex-shrink: 0;
`;
export const ImageInfo = styled.div `
  display: grid;
  gap: var(--space-250);
`;
export const ImageInfoRecommendedSize = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`;
